import { AppointmentAdvancePayment } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

export function isAdvancePaymentVisible(
   advancePayment: AppointmentAdvancePayment | null,
   onlinePaymentsIntegrationExists: boolean
): boolean {
   if (!advancePayment || !onlinePaymentsIntegrationExists) {
      return false;
   }

   return (
      advancePayment.paidAmount.asNumber() > 0 ||
      advancePayment.requiredAmount.asNumber() > 0 ||
      advancePayment.pendingOnlinePaymentsTotalAmount.asNumber() > 0 ||
      advancePayment.remainingAmount.asNumber() > 0
   );
}
